// v14at-p4 F4 — AutoMeasure background jobs API-wrappers.
//
// Deze module bundelt de 4 endpoints van F3 + een feature-flag check.
// Bestaande synchrone `autoMeasureLookup` blijft in `lib/api.js` staan en
// wordt NIET geraakt.
import { api } from "./api";

export const createMeasurementJob = (payload) =>
  api.post(`/automeasure/jobs`, payload).then((r) => r.data);

export const getMeasurementJob = (jobId) =>
  api.get(`/automeasure/jobs/${jobId}`).then((r) => r.data);

export const applyMeasurementJob = (jobId, payload) =>
  api.post(`/automeasure/jobs/${jobId}/apply`, payload).then((r) => r.data);

export const cancelMeasurementJob = (jobId) =>
  api.delete(`/automeasure/jobs/${jobId}`).then((r) => r.data);

// Compile-time flag (CRA + webpack DefinePlugin). Wijzigen van .env vereist
// een rebuild/redeploy; wordt NIET at-runtime herlezen.
export const isAsyncJobsEnabled = () =>
  String(process.env.REACT_APP_AUTOMEASURE_ASYNC_ENABLED || "false").toLowerCase() === "true";
